import * as React from "react";
// import LoginPopup from "../generic/loginPopup";
import {
  Link,
  RouteChildrenProps,
  useHistory,
  useLocation,
  useParams,
} from "react-router-dom";
import { urls } from "../../../login/loginConstants";
// import "../../../assets/scss/components/login/loginScreen/loginHelp.scss";
export interface ILoginHelpProps {}

const NavList = [
  {
    value: "myProfile",
    display: "My Profile",
    href: "profile",
  },
  {
    value: "message",
    display: "Message Center",
    href: "messages",
  },
  {
    value: "serviceReq",
    display: "Service Request",
    href: "service-request",
  },
  {
    value: "rateCharges",
    display: "Rate & Charges",
    href: "rates-charges",
  },
  {
    value: "exchangeMessLogs",
    display: "Exchange Message Logs",
    href: "exchange-logs",
  },
];
const NavBar: React.FC<any> = (props) => {
  const [selectedValue, setSelectedValue] = React.useState("Service Request");
  let location = useLocation().pathname;
  React.useEffect(() => {
    let set = NavList.filter((list) => {
      if (location.includes(list.href)) return list;
    })[0].value;
    navSelected(set);
  }, []);
  const navSelected = (value: string) => {
    setSelectedValue(value);
  };

  return (
    <>
      <div className="edelHeader ">
        <div className="tag_navigation_edel">
          <div className="wrapper setMinHgt">
            <div className="topmenuArea client-area-tab">
              <ul className="tag_navigation_content ml-5">
                {NavList.map((nav) => (
                  <li
                    className={
                      "tag" + (nav.value === selectedValue ? " active" : "")
                    }
                    key={nav.value}
                    onClick={() => navSelected(nav.value)}
                  >
                    {nav.href && (
                      <Link className="notification" to={nav.href}>
                        <span>{nav.display}</span>
                        {props[`${nav.value}`] > 0 && (
                          <span className="badge">{props[`${nav.value}`]}</span>
                        )}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NavBar;
